import React, { forwardRef } from 'react';
import { useIntl } from 'react-intl';

import { IS_DE_LANG_ENV } from 'config/env';
import { SectionNavigation, sectionTitles } from 'modules/ui';
import { Offices } from 'modules/offices';
import { BookCallSection } from 'modules/inquiry';
import { CaseStudies } from 'modules/case-studies';

import HeroSection from './HeroSection';
import { OurServices } from './OurServices';
import OurAwards from './OurAwards';
import { DeIntroduction } from './DeIntroduction';

import { PixelatedBackgroundWrapper } from './PixelatedBackgroundWrapper';

export const HomePage = forwardRef<HTMLElement>((props, footerRef) => {
    const heroRef = React.useRef(null);
    const caseRef = React.useRef(null);
    const servicesRef = React.useRef(null);
    const officesRef = React.useRef(null);

    const sections = {
        hero: {
            ref: heroRef,
            title: sectionTitles.hero.homepage,
            id: 1,
        },
        case: {
            ref: caseRef,
            title: sectionTitles.caseStudies.homepage,
            id: 2,
        },
        services: {
            ref: servicesRef,
            title: sectionTitles.services.homepage,
            id: 3,
        },
        offices: {
            ref: officesRef,
            title: sectionTitles.offices.homepage,
            id: 4,
        },
        footer: {
            ref: footerRef,
            title: sectionTitles.footer,
            id: 6,
        },
    };

    return (
        <PixelatedBackgroundWrapper ref={servicesRef}>
            <HeroSection reference={heroRef} />
            <CaseStudies ref={caseRef} lazyLoaded />
            {IS_DE_LANG_ENV && <DeIntroduction />}
            <OurAwards ref={servicesRef} />
            <OurServices ref={servicesRef} />
            <Offices ref={officesRef} lazyLoaded />
            <BookCallSection hasPaddingBottom modalVariant={false} ref={officesRef}/>

            <SectionNavigation sections={sections} />
        </PixelatedBackgroundWrapper>
    );
});
